import { Component, OnChanges } from '@angular/core';
import { BusinessParticularityOption } from '../options.component';
import { BusinessParticularities, BUSS_PART_CONST } from '@shared-logic/business-particularities';

@Component({
  selector: 'app-negocio-av',
  templateUrl: './negocio-av.component.html',
  styleUrls: ['./../options.component.scss', './../../../fields.component.scss']
})
export class NegocioAvComponent extends BusinessParticularityOption implements OnChanges {
  // Read from the shared constant: the same literal is the filter name-to-tag key,
  // so it must be defined once and never duplicated in the template.
  readonly label: string = BUSS_PART_CONST.avBusiness;

  isAvBusiness: boolean = false;

  constructor() {
    super()
  }

  ngOnChanges(): void {
    this.isAvBusiness = this.businessParticularitiesStruct?.avBusiness ?? false;
  }

  setIsAvBusiness(): void {
    this.isAvBusiness = !this.isAvBusiness;
    const newBP: BusinessParticularities = JSON.parse(JSON.stringify(this.businessParticularitiesStruct));
    newBP.avBusiness = this.isAvBusiness;
    this.emit2(newBP);
  }
}
